export default __webpack_public_path__ + "static/media/logo_auth.ca8e4357.png";